import { ErrorResponse, ILicensePlateInfoForm } from '../types/form';
import { ApiResources, createErrorResponse, getRequestHeaders, getUrl, Methods, processResponse } from './utils';

export interface IPostPlateToVINResponse {
  assetId: string | null;
  vin: string;
  make: string;
  model: string;
  year: string;
  isSuccess: boolean;
  message: null | string;
}

export const postPlateToVIN = async (
  licensePlateInfoPayload: ILicensePlateInfoForm
): Promise<IPostPlateToVINResponse | ErrorResponse> => {
  const endpoint = `${getUrl(ApiResources.getVIN)}`;
  const request = {
    method: Methods.post,
    headers: await getRequestHeaders(),
    body: JSON.stringify(licensePlateInfoPayload),
  };
  try {
    const jsonResponse = await fetch(endpoint, request);
    return processResponse(jsonResponse);
  } catch (error) {
    return createErrorResponse(error instanceof Error ? error.name : 400, error instanceof Error ? error.message : '');
  }
};
